var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9375 11.7188C15.9375 12.3053 15.4615 12.7812 14.875 12.7812H13.7371C13.5007 11.8664 12.6767 11.1875 11.6875 11.1875H5.3125C4.32331 11.1875 3.49934 11.8664 3.26294 12.7812H2.125C1.5385 12.7812 1.0625 12.3053 1.0625 11.7188V10.6562C1.0625 10.0697 1.5385 9.59375 2.125 9.59375H14.875C15.4615 9.59375 15.9375 10.0697 15.9375 10.6562V11.7188ZM11.6875 14.375H5.3125C4.726 14.375 4.25 13.899 4.25 13.3125C4.25 12.726 4.726 12.25 5.3125 12.25H11.6875C12.274 12.25 12.75 12.726 12.75 13.3125C12.75 13.899 12.274 14.375 11.6875 14.375ZM4.25 2.6875C4.25 2.101 4.726 1.625 5.3125 1.625H11.6875C12.274 1.625 12.75 2.101 12.75 2.6875V8.53125H4.25V2.6875ZM14.875 8.53125H13.8125V2.6875C13.8125 1.51397 12.861 0.5625 11.6875 0.5625H5.3125C4.13897 0.5625 3.1875 1.51397 3.1875 2.6875V8.53125H2.125C0.951469 8.53125 0 9.48272 0 10.6562V11.7188C0 12.8923 0.951469 13.8438 2.125 13.8438H3.26294C3.49934 14.7591 4.32331 15.4375 5.3125 15.4375H11.6875C12.6767 15.4375 13.5007 14.7591 13.7371 13.8438H14.875C16.0485 13.8438 17 12.8923 17 11.7188V10.6562C17 9.48272 16.0485 8.53125 14.875 8.53125Z",
    fill: "#F8B117"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print_icon.8bc4a30c6b536758014624d5eeefebb7.svg";
export { ForwardRef as ReactComponent };